import Axios from "../../api/Axios";

const BASE_URL = "ParameterSettings/";
export const Endpoint = {
    SaveInvoice: "SaveInvoice",
    GetEInvoiceItem: "GetEInvoiceItem",
};
// /api/BeatFrequencyPlanning/DownloadTemplate
// /api/BeatFrequencyPlanning/UploadExcel
export const createAPIEndpntAddEInvoice = () => {
    return { get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint,data)=> Axios.post(BASE_URL+Endpoint,data)
    };
};